
import TextareaProps from './mixins/TextareaProps';
import { TextareaPropertyType, TextAreaResizeType } from './enums';
import StyleClassNamesBuilder from '../../../../../styles/helpers/StyleClassNamesBuilder';
import { StyleFillType } from '../../../../input/enums';
import { StyleColorSchemeType } from '../../../../../styles/enums';
import { ControlEventType } from '../../enums/index';

export default {
  name: 'Textarea',
  mixins: [
    TextareaProps,
  ],
  data() {
    return {
      isFocused: false,
      TextareaPropertyType,
    };
  },
  computed: {
    wrapperClassNames() {
      return new StyleClassNamesBuilder('textarea')
        .addColorSchemeConditionClassNames(this.conditionColorScheme)
        .addConditionClassNames(Object.values(StyleFillType), this[TextareaPropertyType.FillType])
        .addClassName(this.className)
        .addConditionClassNames(
          Object.values(TextAreaResizeType),
          this[TextareaPropertyType.Resize],
        )
        .addConditionClassName('disabled', this.disabled)
        .build();
    },
    showError() {
      return !!this[TextareaPropertyType.Error];
    },

    labelText() {
      return this.required
        ? `${this[TextareaPropertyType.Label]} *`
        : this[TextareaPropertyType.Label];
    },
    conditionColorScheme() {
      if (this.showError) {
        return StyleColorSchemeType.Danger;
      }

      if (this.disabled) {
        return StyleColorSchemeType.GrayLight;
      }

      if (this.isFocused) {
        return StyleColorSchemeType.Secondary;
      }

      return this[TextareaPropertyType.ColorScheme];
    },
    charLimit() {
      const hasCharLimitHint = this[TextareaPropertyType.HasCharLimitHint];
      const maxLength = this[TextareaPropertyType.Maxlength];

      if (!hasCharLimitHint || !maxLength) {
        return null;
      }

      const currentValueLength = this[TextareaPropertyType.Value]?.length || 0;

      return `${currentValueLength} / ${maxLength}`;
    },
  },
  methods: {
    handleChange(event) {
      this.$emit(ControlEventType.Change, event.target.value);
    },
    handleFocus(event) {
      this.isFocused = true;
      this.$emit(ControlEventType.Focus, event.target.value);
    },
    handleBlur(event) {
      this.isFocused = false;
      this.$emit(ControlEventType.Blur, event.target.value);
    },
  },
};
